import React from "react";
import { gql } from "graphql-tag";
import { useMutation } from "@apollo/client";
import { templateGroups_templateGroups as ExtendedTemplate, removeTemplateGroup, removeTemplateGroupVariables } from "types/gql-types";
import { RemoveModal } from "components/modal/remove";

const REMOVE_TEMPLATE = gql`
  mutation removeTemplateGroup($id: ID!) {
    removeTemplateGroup(id: $id) {
      id
    }
  }
`;

type Props = {
  template: ExtendedTemplate;
};

const DELETE_TEMPLATE_CONFIRM = "Are you sure you want to delete this template?";
const DELETE_ERROR =
  "Unable to delete this template. Please try again or contact support@havenconnect.com.";

export const RemoveTemplate: React.FC<Props> = ({ template }) => {
  const [removeTemplate] =
  useMutation<removeTemplateGroup, removeTemplateGroupVariables>(REMOVE_TEMPLATE);

  const action = () => removeTemplate({
    variables: { id: template.id },
    refetchQueries: ["templateGroups"], // refetches templates
  });

  return (<RemoveModal
    action={action}
    buttonText="Delete"
    removalText={DELETE_TEMPLATE_CONFIRM}
    errorText={DELETE_ERROR}
  />);
};
